import React from "react";
import PropTypes from "prop-types";
import ActionCard from "components/CaseManagement/CaseDetail/Action/ActionCard";
import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

const OPEN = 0;

export default function ActionList(props) {
  const { loading, error, actions, tabStatus, caseId } = props;

  if (loading || error || !actions) {
    return <Skeleton variant="rectangular" height={45} />;
  }

  const isActionOpen = ({ action_status_detail }) => {
    return (
      action_status_detail?.name !== "Completed" &&
      action_status_detail?.name !== "Canceled"
    );
  };

  const filteredActions =
    tabStatus === OPEN
      ? actions.filter(x => isActionOpen(x))
      : actions.filter(x => !isActionOpen(x));

  if (!filteredActions || !filteredActions.length)
    return <NoActionList>No action entries yet.</NoActionList>;
  return filteredActions.map((action, index) => {
    return <ActionCard key={index} action={action} caseId={caseId} />;
  });
}

ActionList.propTypes = {
  actions: PropTypes.array,
  tabStatus: PropTypes.number,
  loading: PropTypes.bool,
  error: PropTypes.any,
  caseId: PropTypes.number
};

const NoActionList = styled("div")`
  text-align: center;
  padding: 10px;
  font-size: 15px;
`;
